import { boot } from 'quasar/wrappers';

export const constants = {
  // Country codes
  COUNTRY_GB: 89,
  COUNTRY_UK: 244,

  // Organisations
  CRAFT: 1,
  ROYAL_ARCH: 2,
  LODGE: 1,
  CHAPTER: 2,

  // PhoneTypes
  PHONE_TYPE_MOBILE: 1,
  PHONE_TYPE_HOME: 2,
  PHONE_TYPE_WORK: 3,
  PHONE_TYPE_OTHER: 4,

  // Rank Classifications
  RANK_CLASSIFICATION_GRAND: 1,
  RANK_CLASSIFICATION_PROVINCIAL: 2,
  RANK_CLASSIFICATION_METROPOLITAN: 3,
  RANK_CLASSIFICATION_DISTRICT: 4,
  RANK_CLASSIFICATION_OVERSEAS: 5,
  RANK_CLASSIFICATION_GRAND_PROVINCIAL: 6,
  RANK_CLASSIFICATION_GRAND_METROPOLITAN: 7,
  RANK_CLASSIFICATION_GRAND_DISTRICT: 8,
  RANK_CLASSIFICATION_GRAND_OVERSEAS: 9,

  // Skills & Interests Type
  SKILL_INTEREST_MASONIC: 1,
  SKILL_INTEREST_GENERAL: 2,
  SKILL_INTEREST_SHARED: 3,

  // Unit Statuses
  LODGE_STATUS_NORMAL: 1,
  CHAPTER_STATUS_NORMAL: 2,
  LODGE_STATUS_NOT_MEETING: 8,
  CHAPTER_STATUS_NOT_MEETING: 9,

  // Unit Subscription Statuses
  SUBSCRIBING: 1,
  PAST: 2,
  HONORARY: 3,

  // Visibility
  VISIBILITY_PRIVATE: 1,
  VISIBILITY_UNIT: 2,
  VISIBILITY_REGION: 3,
  VISIBILITY_GLOBAL: 4,
} as const;

export type Constants = typeof constants;

export default boot(({ app }) => {
  app.config.globalProperties.$constants = constants;
});
